import { Model, AccessorsMutatorsDecorator } from "../../helpers";

/**
 * @class PaginationCollection
 * @template M
 * @property {number[]} perPageOptions
 * @property {number} perPage
 * @property {number} page
 * @property {number} total
 * @property {M[]} models
 */
export class PaginationCollection extends Model {

    /**
     * @param {Object.<string, *>} attributes
     */
    constructor(attributes = {}) {

        super(Object.assign({
                                perPageOptions: [ 10, 25, 50, 100 ],
                                perPage: 25,
                                page: 1,
                                total: 0,
                                total_row: {},
                                models: []
                            }, attributes));
    }
}

AccessorsMutatorsDecorator(
    'perPageOptions',
    'perPage',
    'page',
    'total',
    'total_row',
    'models',
    'from',
    'to'
)(PaginationCollection);



// WEBPACK FOOTER //
// ./src/pms-api/models/pagination-collection.model.js